export default __webpack_public_path__ + "static/media/not-sure.1b971b6e.svg";